import HttpService from "./HttpService";
import ConstantList from "../appConfig";
import axios from "axios";

const API_PATH = ConstantList.API_EN_POINT + "/file-ext";

/**
 * Lấy file theo ID
 * Dùng chung HttpService => tự ăn interceptor (loading, token, error…)
 */
export const getFileById = (fileId) => {
  return HttpService.getAxiosClient().get(
    API_PATH + "/getbyid/" + fileId,
    {
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

/**
 * Upload file
 */
export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append("uploadfile", file); //Lưu ý tên 'uploadfile' phải trùng với tham số bên Server side

  return axios.post(API_PATH + "/upload-file", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
